import { render, staticRenderFns } from "./Fahrdienst.vue?vue&type=template&id=06cd8098&scoped=true&"
import script from "./Fahrdienst.vue?vue&type=script&lang=js&"
export * from "./Fahrdienst.vue?vue&type=script&lang=js&"
import style0 from "./Fahrdienst.vue?vue&type=style&index=0&id=06cd8098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd8098",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
